export default {
	title: 'Sensor',
	selectAll: 'Seleccionar Todo',
	selectedCount: '{count} elementos seleccionados',
	batchDelete: 'Eliminar en Lote',
	batchDeleteWithCount: 'Eliminar en Lote ({count})',
	noData: {
		title: 'No Hay Datos de Sensor',
		description: 'No se encontraron datos de sensor'
	},
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote',
		diagnose: 'Diagnosticar',
		setOffset: 'Establecer Desplazamiento',
		triggerAlarm: 'Activar Alarma',
		uploadWaveform: 'Subir Onda',
		algorithmModelConfig: 'Configuración del Modelo del Algoritmo',
		warnLevelLimit: 'Límite superior del nivel de alarma',
		refreshAlgorithmModel: 'Actualizar Modelo de Algoritmo',
		oneKeyTest: 'Prueba Rápida'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		selectSensorWarning: 'Por favor seleccione sensor',
		selectFileRequired: 'Por favor seleccione archivos para subir',
		uploadSuccess: 'Subida exitosa',
		uploadFailed: 'Subida fallida',
		alarmTimeRequired: 'Por favor seleccione hora de inicio y hora de finalización',
		alarmTimeInvalid: 'La hora de inicio debe ser anterior a la hora de finalización',
		alarmTriggerSuccess: 'Alarma activada con éxito',
		confirmRefreshAlgorithmModel:
			'¿Está seguro de que desea actualizar el modelo del algoritmo? Esta operación regenerará la configuración del modelo.',
		confirmRefresh: 'Confirmar Actualización',
		refreshAlgorithmModelSuccess: 'Modelo del algoritmo actualizado exitosamente',
		fileSizeExceeded: 'El tamaño del archivo no puede exceder {size}MB',
		fileTypeNotSupported: 'Solo se admiten archivos en formato {type}',
		confirmTrigger: 'Confirmar Activación',
		pleaseSelectAlgorithmModelGroup: 'Por favor seleccione grupo del modelo del algoritmo',
		pleaseSelectWarnLevelLimit: 'Por favor seleccione límite superior del nivel de alarma',
		configSuccess: 'Configuración exitosa',
		paramNamePlaceholder: 'Por favor ingrese el nombre del parámetro',
		delete: 'Eliminar',
		addRow: '+ Agregar Fila'
	},
	form: {
		projNo: 'Proyecto',
		name: 'Nombre del Punto de Medición',
		pointNo: 'Número del Punto de Medición',
		deviceName: 'Nombre del Dispositivo',
		model: 'Modelo',
		orgId: 'Organización (Diagnóstico)',
		deviceId: 'Dispositivo',
		direction: 'Dirección de Instalación',
		axisCount: 'Número de Ejes',
		typeId: 'Tipo de Punto',
		pointType: 'Tipo de Negocio',
		cylinderId: 'Seleccionar Cilindro',
		sort: 'Ordenar',
		sensorImage: 'Imagen del Sensor',
		diagnoseGroupCode: 'Grupo del Modelo del Algoritmo',
		warnLevelLimit: 'Límite Superior del Nivel de Alarma',
		configOffLineTime: 'Tiempo Fuera de Línea (minutos)',
		placeholder: {
			projNo: 'Por favor seleccione proyecto',
			name: 'Por favor ingrese el nombre del punto de medición',
			pointNo: 'Por favor ingrese el número del punto de medición',
			deviceName: 'Por favor ingrese el nombre del dispositivo',
			model: 'Por favor ingrese el modelo',
			orgId: 'Por favor seleccione organización (diagnóstico)',
			deviceId: 'Por favor seleccione dispositivo',
			direction: 'Por favor seleccione dirección de instalación',
						axisCount: 'Por favor introduzca el número de ejes',
			typeId: 'Por favor seleccione tipo de punto',
			pointType: 'Por favor seleccione tipo de negocio',
			cylinderId: 'Por favor seleccione cilindro',
			sort: 'Por favor ingrese ordenar',
			diagnoseGroupCode: 'Por favor seleccione grupo del modelo del algoritmo',
			configOffLineTime: 'Por favor ingrese tiempo fuera de línea'
		}
	},
	table: {
		name: 'Nombre del Punto de Medición',
		pointNo: 'Número del Punto de Medición',
		deviceName: 'Nombre del Dispositivo',
		typeId: 'Tipo',
		pointTypeName: 'Tipo de Negocio',
		power: 'Energía',
		direction: 'Dirección de Instalación',
		sensorStatus: 'Estado del Sensor',
		onlineStatus: 'Estado de la Comunicación',
		model: 'Modelo',
		orgPath: 'Ruta',
		diagnoseGroupCode: 'Grupo del Modelo del Algoritmo'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		close: 'Cerrar',
		uploadWaveformTitle: 'Subir Archivo de Onda',
		alarmTimeRangeTitle: 'Seleccionar Rango de Tiempo de Alarma',
		algorithmModelConfigTitle: 'Configuración del Modelo del Algoritmo',
		warnLevelLimitConfigTitle: 'Configuración del Límite Superior del Nivel de Alarma',
		selectedSensor: 'Sensor Seleccionado',
		testResultTitle: 'Resultado de la Prueba'
	},
	warnLevel: {
		general: 'General',
		medium: 'Medio',
		serious: 'Grave'
	},
	upload: {
		selectFile: 'Seleccionar Archivo',
		dragTip: 'Arrastre los archivos aquí, o',
		clickUpload: 'haga clic para subir',
		tip: 'Admite la subida múltiple de archivos, máximo 200 archivos, cada archivo máximo {size}MB',
		upload: 'Subir'
	},
	alarm: {
		startTime: 'Hora de Inicio',
		endTime: 'Hora de Finalización',
		pleaseSelectStartTime: 'Seleccionar Hora de Inicio',
		pleaseSelectEndTime: 'Seleccionar Hora de Finalización'
	},
	offset: {
		title: 'Establecer Desplazamiento',
		paramName: 'Nombre del Parámetro',
		paramNamePlaceholder: 'Por favor ingrese el nombre del parámetro',
		delete: 'Eliminar',
		addRow: '+ Agregar Fila',
		columns: {
			ZA: 'Z-A',
			ZB: 'Z-B',
			XA: 'X-A',
			XB: 'X-B',
			YA: 'Y-A',
			YB: 'Y-B'
		}
	},
	testResult: {
		selectedPoints: 'Puntos Seleccionados',
		testingSubtitle: 'Comprobando el estado de las características del punto, espere...',
		doneSubtitle: 'Verificación completada para {count} puntos',
		loadingTip1: 'Enviando comando de prueba...',
		loadingTip2: 'Recopilando el estado de las características...',
		loadingTip3: 'Resumiendo los resultados de la prueba...',
		retest: 'Repetir Prueba',
		copyJson: 'Copiar JSON',
		export: 'Exportar CSV',
		done: 'Prueba Completada',
		testTime: 'Hora de Prueba',
		totalCount: 'Puntos Totales',
		online: 'En Línea',
		offline: 'Desconectado',
		status: 'Estado',
		lastTime: 'Última Hora',
		emptyResult: 'No se obtuvieron resultados de prueba',
		failed: 'La prueba falló, inténtelo de nuevo más tarde',
		copySuccess: 'Copiado con éxito',
		exportSuccess: 'Exportado con éxito'
	}
}
